var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"mb-2",attrs:{"color":"primary","disabled":_vm.disabled},on:{"click":_vm.persistListView}},[_vm._v("Save")])}
var staticRenderFns = []

export { render, staticRenderFns }